import { render, staticRenderFns } from "./xheader.vue?vue&type=template&id=2349df0d&scoped=true&"
var script = {}
import style0 from "./xheader.vue?vue&type=style&index=0&id=2349df0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349df0d",
  null
  
)

export default component.exports